import { useEffect, useState } from "react";
import DRX_LOGO from "@/assets/icons/drx-logo-black.svg";
import DRX_TEXT from "@/assets/icons/drx-text-black.svg";
import SubMenuItem from "./SubMenuItem";
import MenuItem from "./MenuItem";
import { SIDEBAR_CONF } from "./constant";
import { MenuValue } from "./model";
import UserInfo from "./UserInfo";
import { useNavigate, useLocation } from "react-router-dom";
import "./style.scss";
import useAuth from "@/hooks/useAuth";

const Sidebar = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState<MenuValue>("");
  const [activeSubMenu, setActiveSubMenu] = useState<MenuValue>("");

  const allowedMenu = SIDEBAR_CONF.filter(menu => menu.allow.includes(auth.role))

  useEffect(() => {
    const pathName: any = location.pathname;
    const result: any = pathName.split("/")[1];
    setActiveMenu(result);
  }, [location]);

  const onClickMenu = (value: MenuValue, path: string) => {
    setActiveMenu(value);

    if (path) {
      // navigate route here!
      navigate(path);
    }
  };

  const onClickSubMenu = (value: MenuValue, path: string) => {
    setActiveSubMenu(value);

    if (path) {
      // navigate route here!
      navigate(path);
    }
  };

  return (
    <div className="sidebar-component-wrapper">
      <div className="sidebar-header">
        <img src={DRX_LOGO} alt="drx-logo" />
        <img src={DRX_TEXT} alt="drx-text" />
      </div>
      
      <div className="sidebar-menus-container">
        {allowedMenu.map((menuItem) => (
          <span key={menuItem.value}>
            <MenuItem
              activeMenu={activeMenu}
              menuItem={menuItem}
              onClickMenu={onClickMenu}
            />
            <>
              {activeMenu === menuItem.value && menuItem.subMenus.length ? (
                <div className="submenus-wrapper">
                  {menuItem.subMenus.map((subMenuItem) => (
                    <SubMenuItem
                      key={subMenuItem.value}
                      activeSubMenu={activeSubMenu}
                      subMenuItem={subMenuItem}
                      onClickSubMenu={onClickSubMenu}
                    />
                  ))}
                </div>
              ) : null}
            </>
          </span>
        ))}

        <UserInfo />
      </div>
    </div>
  );
};

export default Sidebar;
